// extracted by mini-css-extract-plugin
module.exports = {"ProfileBankNews":"ProfileBankNews_ProfileBankNews___f3Ax"};